import React, {useCallback, useRef, useState} from 'react';

import {memo} from '_/utilities/memo';
import {Positioning} from '_/utilities/types';

import {Content, StyledButton} from './styles';

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Icon component for the button
   */
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  bordered?: boolean;
  danger?: boolean;
  flat?: boolean;
  testId?: string;
  iconPlacement?: IconPlacement;
  /** Flag that rotates the icon b ythe amount in degrees, useful for chevrons and similar icons */
  iconRotation?: number;
  selectBoxPlacement?: Positioning;

  ref?: React.Ref<HTMLButtonElement>;
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export type IconButtonProps = Omit<Props, 'children'>;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export enum IconPlacement {
  Left,
  Right,
  Middle,
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export function ButtonComponent(
  {
    Icon,
    bordered: _bordered,
    children,
    danger: _danger,
    flat: _flat,
    testId,
    iconPlacement = IconPlacement.Right,
    iconRotation = 0,
    onClick,
    ...props
  }: Props,
  ref: React.Ref<HTMLButtonElement>
): React.ReactElement {
  const [expanded, setExpanded] = useState(false);

  const internalRef = useRef<HTMLButtonElement>(null);

  const handleClick = useCallback(
    (event: any) => {
      if (!onClick && !expanded) {
        setExpanded(true);
      }

      onClick?.(event);
    },
    [expanded, onClick]
  );

  const refCallback = useCallback(
    (element: HTMLButtonElement) => {
      (internalRef as React.MutableRefObject<HTMLButtonElement>).current =
        element;

      /* istanbul ignore if */
      if (ref) {
        if (typeof ref === 'function') {
          /* istanbul ignore next */
          ref(internalRef.current);
        } else {
          (ref as React.MutableRefObject<HTMLButtonElement | null>).current =
            internalRef.current;
        }
      }
    },
    [ref]
  );

  return (
    <button
      ref={refCallback}
      data-testid={testId}
      onClick={handleClick}
      {...props}
    >
      <Content iconPlacement={iconPlacement} iconRotation={iconRotation}>
        {Icon ? <Icon /> : null}
        {children}
      </Content>
    </button>
  );
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export default memo(ButtonComponent, StyledButton, true);
